import React from "react";
import slugifyString from "../../helpers/slugifyString";
import { Box } from "@rebass/grid";
import { Link } from "react-router-dom";
import AddressLink from "../AddressLink/AddressLink";
import LoadingBlock from "../LoadingBlock/LoadingBlock";

import "./biz-preview.scss";
import ProgressiveLoader from "../ImageLoader/ProgressiveLoader";
import ServiceOptions from "./ServiceOptions";

const BizPreview = ({
  name,
  images,
  address,
  businessDescription,
  pickup,
  delivery,
  loading = false,
  lazy,
  ...business
}) => {
  return (
    <Box px={3} py={3} width={[1, 1 / 2, 1 / 3]}>
      {loading === true && (
        <>
          <LoadingBlock />

          <div className="para name">
            <LoadingBlock height={20} margin={5} />
          </div>
          <div className="para address">
            <LoadingBlock height={20} margin={5} />
          </div>
          <div className="para">
            <LoadingBlock height={20} margin={5} />
          </div>
        </>
      )}

      {loading === false && (
        <>
          <Link to={`/business/${slugifyString(name)}`}>
            <ProgressiveLoader
              image={images && images[0] ? images[0] : ""}
              lazy={lazy}
            >
              <ServiceOptions
                loading={loading}
                pickup={pickup}
                delivery={delivery}
              />
            </ProgressiveLoader>
          </Link>

          {name && <div className="para name">{name}</div>}
          {address && (
            <div className="para address">
              <AddressLink {...business} address={address} />
            </div>
          )}

          {businessDescription && (
            <div className="para">
              {businessDescription.length > 200
                ? `${businessDescription.substring(0, 200)} ...`
                : businessDescription}
            </div>
          )}
          {name && (
            <Link className="biz-link" to={`/business/${slugifyString(name)}`}>
              Learn more
            </Link>
          )}
        </>
      )}
    </Box>
  );
};

export default BizPreview;
